export const encodeToUrlComponent = (value: unknown) => {
  return encodeURIComponent(JSON.stringify(value));
};

export const decodeFromUrlComponent = <T>(value: string): T | null => {
  try {
    return JSON.parse(decodeURIComponent(value));
  } catch {
    console.warn('[codec-log] decode from url component failed', value);
    return null;
  }
};